import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
    routes: [{
            path: '/',
            component: () => import("@/views/Home/VerloopHome/VerloopHome.vue")
        },
        {
            path: '/pricing.html',
            component: () => import("@/views/Pricing/Pricing.vue")
        },
        {
            path: '/case-studies.html',
            component: () => import("@/views/CaseStudies/CaseStudies.vue")
        },
        {
            path: '/schedule-a-demo',
            component: () => import("@/views/ScheduleADemo.vue")
        },
        {
            path: '/create-whatsapp-chatbot.html',
            component: () => import("@/views/Home/WhatsappHome/WhatsappHome.vue")
        },
        {
            path: '/case-study-acadgild.html',
            component: () => import("@/views/CaseStudies/Acadgild/Acadgild.vue")
        },
        {
            path: '/case-study-apollomunich.html',
            component: () => import("@/views/CaseStudies/ApolloMunich/ApolloMunich.vue")
        },
        {
            path: '/case-study-medibuddy.html',
            component: () => import("@/views/CaseStudies/Mediassist/Mediassist.vue")
        },
        {
            path: '/case-study-nykaa.html',
            component: () => import("@/views/CaseStudies/Nykaa/Nykaa.vue")
        },
        {
            path: '/case-study-o2spa.html',
            component: () => import("@/views/CaseStudies/O2Spa/O2Spa.vue")
        },
        {
            path: '/case-study-kaarva.html',
            component: () => import("@/views/CaseStudies/Kaarva/Kaarva.vue")
        },
        {
            path: '/case-study-waterprojects.html',
            component: () => import("@/views/CaseStudies/WaterProjects/WaterProjects.vue")
        },
        {
            path: '/case-study-marathon.html',
            component: () => import("@/views/CaseStudies/Marathon/Marathon.vue")
        },
        {
            path: '/wordpress-integration.html',
            component: () => import("@/components/Footer/FooterLinks/Integrations/WordpressIntegration/WordpressIntegration.vue")
        },
        {
            path: '/shopify-integration.html',
            component: () => import("@/components/Footer/FooterLinks/Integrations/ShopifyIntegration/ShopifyIntegration.vue")
        },
        {
            path: '/magento-integration.html',
            component: () => import("@/components/Footer/FooterLinks/Integrations/MagentoIntegration/MagentoIntegration.vue")
        },
        {
            path: '/drift-alternative.html',
            component: () => import("@/components/Footer/FooterLinks/Alternatives/Drift/Drift.vue")
        },
        {
            path: '/freshchat-alternative.html',
            component: () => import("@/components/Footer/FooterLinks/Alternatives/Freshchat/Freshchat.vue")
        },
        {
            path: '/intercom-alternative.html',
            component: () => import("@/components/Footer/FooterLinks/Alternatives/Intercom/Intercom.vue")
        },
        {
            path: '/olark-alternative.html',
            component: () => import("@/components/Footer/FooterLinks/Alternatives/Olark/Olark.vue")
        },
        {
            path: '/tawk-to-alternative.html',
            component: () => import("@/components/Footer/FooterLinks/Alternatives/Tawk_to/Tawk_to.vue")
        },
        {
            path: '/zopim-alternative.html',
            component: () => import("@/components/Footer/FooterLinks/Alternatives/Zopim/Zopim.vue")
        },
        {
            path: '/contact.html',
            component: () => import("@/components/Footer/FooterLinks/Misc/ContactUs.vue")
        },
        {
            path: '/privacy.html',
            component: () => import("@/components/Footer/FooterLinks/Misc/Policy.vue")
        },
        {
            path: '/terms.html',
            component: () => import("@/components/Footer/FooterLinks/Misc/Terms.vue")
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
    mode: 'history'
});